import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Grid,
  Alert,
  Collapse,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAddBureauMutation } from '../../app/services/bureauApi';
import CircularProgress from '@mui/material/CircularProgress';


function AddBureau() {
  const [formData, setFormData] = useState({
    nom: '',
    telephone: '',
    email: '',
    adresse: '',
    location: '',
    quartier: '',
    heure_ouverture: '',
    heure_fermeture: '',
    description: '',
  });

  const [image, setImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState({ open: false, type: '', message: '' });

  const [addBureau, { isLoading }] = useAddBureauMutation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nom) newErrors.nom = 'Le nom est requis';
    if (!formData.telephone) newErrors.telephone = 'Le téléphone est requis';
    if (!formData.email) newErrors.email = 'L’email est requis';
    if (!formData.adresse) newErrors.adresse = 'L’adresse est requise';
    if (!formData.quartier) newErrors.quartier = 'Le quartier est requis';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }
    if (image) {
      data.append('image', image);
    }

    try {
      await addBureau(data).unwrap();
      setAlert({
        open: true,
        type: 'success',
        message: 'Bureau ajouté avec succès',
      });
      setFormData({
        nom: '',
        telephone: '',
        email: '',
        adresse: '',
        location: '',
        quartier: '',
        heure_ouverture: '',
        heure_fermeture: '',
        description: '',
      });
      setImage(null);
      setErrors({});
    } catch (error) {
      if (error?.status === 422 && error?.data?.errors) {
        // Erreurs de validation Laravel
        setErrors(error.data.errors);
      } else {
        setAlert({
          open: true,
          type: 'error',
          message: error?.data?.message || "Erreur lors de l'ajout du bureau",
        });
      }
    }
  };

  return (
    <Container
          maxWidth="xl"
          sx={{
            backgroundColor: "#ffff8d",
            pt: 0,
            pb: 2,
            marginTop: 0,
          }}
        >
      <Typography variant="h5" gutterBottom>
        Gestion des bureaux
      </Typography>
      <Typography paragraph>
        Dans cette section, vous pouvez ajouter un bureau de change.
      </Typography>

      {/* Alert Section */}
      <Collapse in={alert.open}>
        <Alert
          severity={alert.type}
          sx={{ mb: 2 }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => setAlert({ ...alert, open: false })}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {alert.message}
        </Alert>
      </Collapse>

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Grid container spacing={2}>
          {[
            { name: 'nom', label: 'Nom' },
            { name: 'telephone', label: 'Téléphone' },
            { name: 'email', label: 'Email' },
            { name: 'adresse', label: 'Adresse' },
            { name: 'location', label: 'Lien Maps (iframe ou URL)' },
            { name: 'quartier', label: 'Quartier' },
            { name: 'heure_ouverture', label: 'Heure ouverture', type: 'time' },
            { name: 'heure_fermeture', label: 'Heure fermeture', type: 'time' },
            { name: 'description', label: 'Description' },
          ].map(({ name, label, type = 'text' }) => (
            <Grid item xs={12} sm={6} key={name}>
              <TextField
                fullWidth
                label={label}
                name={name}
                type={type}
                value={formData[name]}
                onChange={handleChange}
                error={Boolean(errors[name])}
                helperText={errors[name]}
              />
            </Grid>
          ))}

          <Grid item xs={12}>
            <Button variant="contained" component="label">
              Choisir une image
              <input type="file" hidden accept="image/*" onChange={handleImageChange} />
            </Button>
            {image && <Typography mt={1}>{image.name}</Typography>}
          </Grid>

          <Grid item xs={12}>
  <Button
    type="submit"
    variant="contained"
    color="primary"
    disabled={isLoading}
    startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
  >
    {isLoading ? 'Envoi en cours...' : 'Ajouter le bureau'}
  </Button>
</Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default AddBureau;
